import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setResponse } from "Slices/Response/responseSlice";
import { setToast, setLoading, setModal } from "Slices/uiSlice";
import { adminPaquetes, getPaqueteCursos } from "Services/paquete_cursos_service";
import { UploadFileS3 } from "Slices/File/fileSlice";
import { fileUri } from "Constantes/constants";

const initialState = {
    paquetesCursos: [],
    paqueteCursos: {
        idPaquete: null,
        idCategoria: null,
        idIdioma: null,
        titulo: '',
        duracion: 0,
        estado: 1,
        usuario: null,
        cursos: [],
        img: null,
        file: null,
    },
}

export const paqueteCursosSlice = createSlice({
    name: 'paqueteCursos',
    initialState,
    reducers: {
        setPaquetesCursos: (state, action) => {
            state.paquetesCursos = action.payload;
        },
        setPaqueteCursos: (state, action) => {
            state.paqueteCursos = action.payload ?? initialState.tipoAprendizaje;
        },
        updatePaqueteCursosField: (state, action) => {
            const { name, value } = action.payload;
            state.paqueteCursos[name] = value;
        },
        updatePaqueteFavorite: (state, action) => {
            const { idAlterno, favorito } = action.payload;
            const paquete = state.paquetesCursos.find(p => p.idAlterno === idAlterno);
            if (paquete) paquete.favorito = favorito;
        },
        resetPaqueteCursos: (state) => {
            state.paqueteCursos = { ...initialState.paqueteCursos };
        },
    }
});

export const fetchPaqueteCursos = createAsyncThunk(
  "paqueteCursos/fetchPaqueteCursos",
  async (data, { dispatch }) => {
    const resultado = await getPaqueteCursos(data);
    dispatch(setPaquetesCursos(resultado));
  }
);

export const mergePaqueteCursos = createAsyncThunk(
    'paqueteCursos/merge',
    async (data, { dispatch }) => {
        dispatch(setLoading(true))
        const paqueteCursosRes = await adminPaquetes(data);

        if (data.file) {
            console.log(paqueteCursosRes);
            const formData = new FormData();
            formData.append('file', data.file);
            formData.append('tipo', fileUri.portada);
            formData.append('name', `paquete_${paqueteCursosRes.data}.jpg`);
            await dispatch(UploadFileS3(formData));
        }

        dispatch(setResponse(paqueteCursosRes));
        dispatch(setLoading(false));
        dispatch(setModal(false));
        dispatch(setToast(true));
        dispatch(fetchPaqueteCursos({idUsuario: null}));
        dispatch(resetPaqueteCursos())
        setTimeout(() => {
            dispatch(setToast(false));
        }, 3000);
    }
);

export const { setPaquetesCursos, setPaqueteCursos, updatePaqueteCursosField, updatePaqueteFavorite, resetPaqueteCursos } = paqueteCursosSlice.actions;
export default paqueteCursosSlice.reducer;